module.exports = __webpack_public_path__ + "static/media/Fir St, South San Francisco, CA4.b23c26f1.jpg";